import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDatepickerInputEvent } from "@angular/material/datepicker";

@Component({
    selector: 'app-simple-date-picker',
    templateUrl: './simple-date-picker.component.html',
    styleUrls: ['./simple-date-picker.component.scss'],
    standalone: false
})
export class SimpleDatePickerComponent implements OnInit {
  @Input() data: any;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  @Input() disabledFlag: boolean;
  @Input() label: string = "";
  @Input() placeholder: string = "";
  @Input() idString: string;
  @Input() dataDate;

  inputId: string;

  tempValue: any;

  constructor() {}

  ngOnInit() {
    this.data = this.dateSet(this.data);
    this.inputId = this.idString + "_input";
  }

  onFocusOut(event: MatDatepickerInputEvent<Date>) {
    this.data = event.value;
    this.focusOut.emit( this.convertDate(this.data) );
  }

  startEdit() {
    this.tempValue = this.data;
  }

  undo() {
    this.data = this.tempValue;
  }

  convertDate(date: Date) {
    let month = date.getMonth() + 1;
    return month + "/" + date.getDate() + "/" + date.getFullYear();
  }

  dateSet(dateString) {
    if(!dateString) {
      return new Date().toISOString();
    }
    if(!this.isValidDate(dateString)) return String();
    return (new Date(dateString)).toISOString();
  };

  isValidDate(dateString) {
    let d = new Date(dateString);
    return d instanceof Date && !isNaN(d.getDate());
  }
}
